import Modal from "react-bootstrap/Modal";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import TextArea from "../sharedComponents/textarea/textArea";
import TextInput from "../sharedComponents/inputs/textInput";
import { useEffect, useState } from "react";
import FileUploader from "../reusableComponents/fileUploader";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Alerts from "../reusableComponents/alert";
import FilesList from "../reusableComponents/filesList";
import Button from "../sharedComponents/buttons/button";
import { addTaskForm } from "../../API/store/actions/tasks";
import { useSelector } from "react-redux";
import "./tasksStyle.css";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { layersIconAdd } from "../reusableComponents/svgIcons";
import MembersList, { removeItem } from "../../algorithms/listsAlogrithms";
import { moment } from "moment";
import { englishDate } from "../../algorithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import { getCommunitiesWithPermssions } from "../../API/store/actions/community";
import { Col, Row } from "react-bootstrap";
import { loadSectors } from "../../API/services/utilities";
import { loadCommunitiesWithSectors } from "./../../API/services/utilities";
import HomeSlider from "./../layout/HomeSlider/homeSlider";
import { responseDataFormat } from "./../../API/middlewares/resolveRequests";
import axios from "../../API/axiosConfig";
import CheckBox from "../sharedComponents/checkbox/checkbox";
const CreateNewTask = (props) => {
  const {
    onHide,
    communityTaskForm,
    setAdminTaskMembersList,
    setTaskMembersList,
    TaskStatusDropdownList,
    setTaskStatusDropdownList,
    PriorityDropdownList,
    setPriorityDropdownList,
    communityId,
    setProcAdded,
    procAdded,
  } = props;
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  const [actualStartDateError, setActualStartDateError] = useState(false);
  const [actualEndDateError, setActualEndDateError] = useState(false);
  const [AdminTaskMembersLists, setAdminTaskMembersLists] = useState([]);
  const [TaskMembersLists, setTaskMembersLists] = useState([]);
  const [taskType, setTaskTypeLists] = useState([]);

  // if (communityTaskForm?.members) {
  //   setAdminTaskMembersList(communityTaskForm?.members);
  //   setTaskMembersList(communityTaskForm?.members);
  // }
  // if (communityTaskForm?.priorityLkp)
  //   setPriorityDropdownList(communityTaskForm?.priorityLkp);
  // if (communityTaskForm?.taskStatusLkp)
  //   setTaskStatusDropdownList(communityTaskForm?.taskStatusLkp);
  // useEffect(() => {
  //   if (communityTaskForm?.members) {
  //     setAdminTaskMembersLists(communityTaskForm.members);
  //     setTaskMembersLists(communityTaskForm.members);
  //   }

  //   if (communityTaskForm?.priorityLkp) {
  //     setPriorityDropdownList(communityTaskForm.priorityLkp);
  //   }

  //   if (communityTaskForm?.taskStatusLkp) {
  //     setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
  //   }
  // }, [communityTaskForm]);
  const [sectors, setSectors] = useState(null);
  const [sectorId, setSectorId] = useState(null);
  const [communitiesWithSectors, setCommunitiesWithSectors] = useState(null);
  const [data, setData] = useState();
  useEffect(() => {
    resolver(getCommunitiesWithPermssions, setData, 1, 1000, userToken);
    // resolver(loadSectors, setSectors, userToken);
  }, []);
  // console.log(communityTaskForm);

  useEffect(() => {
    if (!sectorId) return;

    resolver(
      loadCommunitiesWithSectors,
      setCommunitiesWithSectors,
      sectorId,
      userToken,
    );
  }, [sectorId]);

  useEffect(() => {
    if (communityTaskForm?.members) {
      setAdminTaskMembersLists(communityTaskForm.members);
      setTaskMembersLists(communityTaskForm.members);
    }

    if (communityTaskForm?.priorityLkp) {
      setPriorityDropdownList(communityTaskForm.priorityLkp);
    }

    if (communityTaskForm?.taskStatusLkp) {
      setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
    }
    if (communityTaskForm?.taskType) {
      setTaskTypeLists(communityTaskForm.taskType);
    }
  }, [communityTaskForm]);

  const userToken = useSelector((state) => state.login.userToken);

  const [files, setFiles] = useState([]);

  const [adminListError, setAdminListError] = useState(false);

  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const user = useSelector((state) => state.login.userData);
  const saveHandler = async (values) => {
    console.log(values);

    try {
      setIsSubmitting(true);

      let formData = new FormData();

      const newData = {
        NameA: values.Name,
        NameE: values.Name,
        DescriptionA: values.Description,
        DescriptionE: values.Description,
        StartDate: englishDate(values.StartDate) + "T00:00:00",
        EndDate: englishDate(values.EndDate) + "T00:00:00",
        ActualStartDate: englishDate(values.ActualStartDate) + "T00:00:00",
        ActualEndDate: englishDate(values.ActualEndDate) + "T00:00:00",
        EstimatedTime: parseInt(values.EstimatedTime),
        PriorityId: parseInt(values.PriorityId),
        TaskStatusId: parseInt(values.TaskStatusId),
        typeId: parseInt(values.typeId),
        AdminTaskMembers: values.AdminTaskMembers,
        TaskMembers: values.TaskMembers,
        ExecutionPercentage: parseInt(values.ExecutionPercentage),
        files: values.files,
        CommunityId: parseInt(values.CommunityId),
        AccessLevelId: parseInt(values.TypeId),
        TaskCountry: values?.Countries,
        ImplementRequirementId: values?.TaskImplementRequirementId,
      };

      if (!values.ActualStartDate) delete newData.ActualStartDate;
      if (!values.ActualEndDate) delete newData.ActualEndDate;
      if (!values.CommunityId) delete newData.CommunityId;
      for (let [key, value] of Object.entries(newData)) {
        if (key == "files") {
          value.forEach((element) => {
            formData.append("files", element.file);
          });
        } else if (key == "AdminTaskMembers") {
          formData.append("AdminTaskMembers", value);
        } else if (key == "TaskMembers") {
          value.forEach((element) => {
            formData.append("TaskMembers", element);
          });
        } else if (key == "TaskCountry") {
          value.forEach((element) => {
            formData.append("TaskCountry", element);
          });
        } else {
          formData.append(key, value);
        }
      }

      if (startDateError === false && endDateError === false) {
        // if (values.AdminTaskMembers.length > 0) {
        //   setAdminListError(false);
        if (disable) {
          return;
        } else {
          setDisable(true);
        }
        for (const [key, value] of formData.entries()) {
          console.log("FORM DATA:", key, value);
        }
        let res = await addTaskForm(formData, userToken);
        if (res.status <= 206) {
          setPriorityDropdownList(communityTaskForm.priorityLkp);
          setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
          setStartDate("");
          setEndDate("");
          setFiles([]);
          resetForm();
          onHide();
          setProcAdded(!procAdded);
          setDisable(false);
        } else {
          setDisable(false);
        }
        // } else {
        //   setAdminListError(true);
        //   setDisable(false);
        // }
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "createNewTask",
      saveHandler,
    ),
  );

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
    resetForm,
  } = formik;
  // useEffect(() => {
  //   console.log("formik errors", errors);
  //   console.log("formik touched", touched);
  // }, [errors, touched]);
  const typeId = values.TypeId;
  const countries = values.Countries || [];
  useEffect(() => {
    if (!typeId) return;

    if (typeId === 2) {
      const all = communityTaskForm?.countryLkp?.map((c) => c.id) || [];
      setFieldValue("Countries", all);
    }

    if (typeId === 1 && countries.length > 1) {
      setFieldValue("Countries", [countries[0]]);
    }

    if (typeId === 3) {
      setFieldValue("Countries", countries);
    }
  }, [typeId]);
  useEffect(() => {
    if (user?.memberId && AdminTaskMembersLists?.length) {
      const memberExists = AdminTaskMembersLists.some(
        (m) => Number(m.memberId) === Number(user.memberId),
      );

      if (memberExists) {
        setFieldValue("AdminTaskMembers", Number(user.memberId));

        setTaskMembersLists(
          AdminTaskMembersLists.filter(
            (m) => Number(m.memberId) !== Number(user.memberId),
          ),
        );
      }
    }
  }, [AdminTaskMembersLists, user]);
  // useEffect(() => {
  //   console.log("values", values);
  // }, [values]);

  // console.log(AdminTaskMembersLists, "sddd", data?.members);
  if (communityTaskForm) {
    return (
      <Modal
        // show={show}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        {...props}
        style={{ zIndex: 1000000 }}
        backdrop="static"
      >
        <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <Modal.Title id="contained-modal-title-vcenter">
            <div className="d-flex align-items-center">
              <div
                style={{
                  backgroundColor: "white",
                  height: 25,
                  width: 30,
                  borderRadius: "50%",
                }}
                className="d-flex justify-content-center text-center align-items-center px-1 mt-1"
              >
                <img
                  src={"/assets/images/add.png"}
                  width={25}
                  height={25}
                  alt=""
                />
              </div>
              <div className="text-dark">
                <p
                  className="my-0 mx-1"
                  style={{
                    fontSize: 18,
                    textAlign: "justify",
                    color: "rgb(12, 87, 76)",
                  }}
                >
                  {Lang.addTask}
                </p>
              </div>
            </div>
          </Modal.Title>
          <div
            className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}
          >
            <Icon
              name="times"
              size={22}
              color={"rgb(12, 87, 76)"}
              onclick={() => {
                onHide();
                setPriorityDropdownList(communityTaskForm.priorityLkp);
                setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
                setStartDate("");
                setEndDate("");
                setFiles([]);
                resetForm();
                setAdminListError(false);
                setDisable(false);
              }}
            />
          </div>
        </Modal.Header>

        <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
          <form onSubmit={handleSubmit}>
            <TextArea
              name={"Name"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.title + "*"}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Name")}
            />
            <TextArea
              name={"Description"}
              containerStyle={"mb-4 col-12 align-items-center"}
              placeholder={Lang.Description}
              rows="3"
              contentStyle={`scroll col-11 p-1`}
              onChange={handleChange}
              errorMessage={formikValidation(touched, errors, "Description")}
            />
            <div className="d-flex flex-xl-row justify-content-center align-items-end col-12 flex-column mt-4">
              <DropDownList
                containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 pe-xl-5 ps-xl-2 ps-4 pe-4`}
                placeholder={Lang.communities}
                border={true}
                // containerStyle={`col-12 mb-1 ps-xl-5 pe-xl-5 ps-4 pe-4`}
                dataSource={data?.data}
                value={values.CommunityId}
                // disabled={values.SectorId == "" ? true : false}
                // enabled={values.SectorId == "" ? false : true}
                change={(e) => {
                  setFieldValue("CommunityId", e.value);
                }}
                errorMessage={formikValidation(touched, errors, "CommunityId")}
              />

              <DropDownList
                containerStyle={`col-12 mb-1 col-xl-6 ps-xl-5 pe-xl-2 ps-4 pe-4`}
                placeholder={Lang.types}
                border={true}
                // containerStyle={`col-12 mb-1 ps-xl-5 pe-xl-5 ps-4 pe-4`}
                dataSource={communityTaskForm?.accessLevelLkp}
                value={values.TypeId}
                // disabled={values.SectorId == "" ? true : false}
                // enabled={values.SectorId == "" ? false : true}
                change={(e) => {
                  setFieldValue("TypeId", e.value);
                }}
                errorMessage={formikValidation(touched, errors, "TypeId")}
              />
            </div>
            <div className="d-flex flex-xl-row justify-content-center align-items-end col-12 flex-column mt-4">
              <DropDownList
                placeholder={Lang.priority + "*"}
                border={true}
                containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 pe-xl-5 ps-xl-2 ps-4 pe-4`}
                dataSource={PriorityDropdownList}
                value={values.PriorityId}
                change={(e) => {
                  setFieldValue("PriorityId", e.value);
                }}
                errorMessage={formikValidation(touched, errors, "PriorityId")}
              />

              <DropDownList
                placeholder={Lang.taskStatus + "*"}
                border={true}
                containerStyle={`col-12 mb-1 col-xl-6 ps-xl-5 pe-xl-2 ps-4 pe-4`}
                dataSource={TaskStatusDropdownList}
                value={values.TaskStatusId}
                change={(e) => {
                  setFieldValue("TaskStatusId", e.value);
                }}
                errorMessage={formikValidation(touched, errors, "TaskStatusId")}
              />
            </div>
            {/* add procedure requirments dropdown start*/}
            <div className="d-flex flex-xl-row justify-content-center align-items-end col-12 flex-column mt-4">
              <DropDownList
                placeholder={"تطلبات تنفيذ الإجراء"}
                border={true}
                dataSource={communityTaskForm?.implementRequirement}
                value={values.TaskImplementRequirementId}
                change={(e) => {
                  setFieldValue("TaskImplementRequirementId", e.value);
                }}
                containerStyle={`col-12 mb-3 mb-xl-1 col-xl-6 pe-xl-5 ps-xl-2 ps-4 pe-4`}
                errorMessage={formikValidation(
                  touched,
                  errors,
                  "TaskImplementRequirementId",
                )}
              />

              <DropDownList
                placeholder="طبيعة الإجراء"
                border={true}
                dataSource={taskType}
                containerStyle={`col-12 mb-1 col-xl-6 ps-xl-5 pe-xl-2 ps-4 pe-4`}
                value={values.typeId}
                change={(e) => {
                  setFieldValue("typeId", e.value);
                }}
                errorMessage={formikValidation(touched, errors, "typeId")}
              />
            </div>
            {/* add procedure requirments dropdown end*/}
            <div className="d-flex flex-xl-row  col-12 flex-column mt-4 mb-4">
              <div
                className={`d-flex flex-column align-items-center col-12 col-xl-12`}
              >
                <p className="px-3 px-xl-5 col-12">{"التاريخ المخطط"}</p>
                <div className="d-flex col-12 flex-xl-row flex-column me-xl-4 px-xl-4 align-items-center  align-items-xl-start">
                  <div className={`col-12 col-xl-6 px-3`}>
                    <DateInput
                      inputStyle={"upperZIndex"}
                      errorMessage={
                        formikValidation(touched, errors, "StartDate") ||
                        startDateError === true
                          ? Lang.invalidDate
                          : null
                      }
                      placeholder={Lang.from}
                      containerStyle={`col-12 col-xl-11 ${styleStart(
                        "m",
                        5,
                        "xl",
                      )}`}
                      name={"StartDate"}
                      value={values.StartDate}
                      onChange={(e) => {
                        setFieldValue("StartDate", e);
                        if (values.EndDate)
                          if (new Date(values.EndDate) >= new Date(e)) {
                            setEndDateError(false);
                            setStartDateError(false);
                          } else setStartDateError(true);
                      }}
                      iconPrefix="far"
                      iconName="calendar"
                      iconSize={22}
                    />
                  </div>

                  <div className={`col-12 align-self-center col-xl-6 px-2`}>
                    <div style={{ width: "95%" }}>
                      <DateInput
                        inputStyle={"upperZIndex"}
                        errorMessage={
                          formikValidation(touched, errors, "EndDate") ||
                          endDateError === true
                            ? Lang.invalidDate
                            : null
                        }
                        placeholder={Lang.to}
                        containerStyle={`col-12 col-xl-11 ${styleStart(
                          "m",
                          3,
                          "xl",
                        )}`}
                        value={values.EndDate}
                        onChange={(e) => {
                          setFieldValue("EndDate", e);
                          if (values.StartDate)
                            if (new Date(values.StartDate) <= new Date(e)) {
                              setEndDateError(false);
                              setStartDateError(false);
                            } else setEndDateError(true);
                        }}
                        iconPrefix="far"
                        iconName="calendar"
                        iconSize={22}
                      />
                    </div>
                    {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
                  </div>
                </div>
              </div>
            </div>
            {/* <MembersList
              containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
              aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={Lang.MainAdminMembers}
              cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                "TitleCard",
              )}`}
              cardTitle={Lang.MainAdminMembers}
              list={AdminTaskMembersLists}
              id={"MainAdmin"}
              checked={true}
              values={values.AdminTaskMembers}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value);

                if (e.target.checked) {
                  setFieldValue("AdminTaskMembers", selectedId);

                  setTaskMembersLists(
                    TaskMembersLists.filter(
                      (item) => parseInt(item.memberId) !== selectedId,
                    ),
                  );

                  setAdminListError(false);
                } else {
                  setTaskMembersLists([
                    ...TaskMembersLists,
                    AdminTaskMembersLists.find(
                      (item) => selectedId === parseInt(item.memberId),
                    ),
                  ]);

                  setFieldValue("AdminTaskMembers", null);
                }
              }}
              listError={touched.AdminTaskMembers && errors.AdminTaskMembers}
            /> */}

            <DropDownList
              placeholder={Lang.MainAdminMembers}
              border={true}
              containerStyle={"mb-4 col-11 align-items-center mx-auto "}
              dataSource={
                AdminTaskMembersLists?.map((item) => ({
                  id: item.memberId,
                  name: item.memberName,
                })) || []
              }
              value={values.AdminTaskMembers ?? undefined}
              change={(e) => {
                const selectedId = e.value;

                setFieldValue("AdminTaskMembers", selectedId);

                setTaskMembersLists(
                  TaskMembersLists.filter(
                    (item) => parseInt(item.memberId) !== parseInt(selectedId),
                  ),
                );

                setAdminListError(false);
              }}
              errorMessage={
                touched.AdminTaskMembers && errors.AdminTaskMembers
                  ? Lang.require
                  : ""
              }
            />
            <MembersList
              containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
              aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={Lang.addSharedAdmainMembers}
              cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                "TitleCard",
              )}`}
              cardTitle={Lang.adminMembers}
              list={AdminTaskMembersLists.filter(
                (item) => item.memberId !== values.AdminTaskMembers,
              )}
              id={"A"}
              checked={true}
              // values={values.AdminTaskMembers}
              values={values.TaskMembers}
              // onChange={(e) => {
              //   if (e.target.checked) {
              //     setFieldValue("AdminTaskMembers", [
              //       ...values.AdminTaskMembers,
              //       parseInt(e.target.value),
              //     ]);
              //     setTaskMembersLists(
              //       TaskMembersLists.filter(
              //         (item) =>
              //           parseInt(item.memberId) !== parseInt(e.target.value),
              //       ),
              //     );
              //     setAdminListError(false);
              //   } else {
              //     setTaskMembersLists([
              //       ...TaskMembersLists,
              //       AdminTaskMembersLists.find(
              //         (item) =>
              //           parseInt(e.target.value) === parseInt(item.memberId),
              //       ),
              //     ]);
              //     setFieldValue(
              //       "AdminTaskMembers",
              //       removeItem(
              //         values.AdminTaskMembers,
              //         parseInt(e.target.value),
              //       ),
              //     );
              //     // if (values.AdminTaskMembers.length > 0) {
              //     //   setAdminListError(false);
              //     // } else {
              //     //   setAdminListError(true);
              //     // }
              //   }
              // }}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value);

                if (e.target.checked) {
                  setFieldValue("TaskMembers", [
                    ...values.TaskMembers,
                    selectedId,
                  ]);
                } else {
                  setFieldValue(
                    "TaskMembers",
                    values.TaskMembers.filter((x) => x !== selectedId),
                  );
                }
              }}
              // listError={adminListError}
            />
            <MembersList
              containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
              aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
              aboveTitle={"إضافة دول"}
              cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                "TitleCard",
              )}`}
              list={communityTaskForm?.countryLkp}
              id={"B"}
              checked={true}
              values={values?.Countries}
              target={true}
              onChange={(e) => {
                const id = parseInt(e.target.id);

                if (typeId === 2) return;

                if (e.target.checked) {
                  if (typeId === 1) {
                    setFieldValue("Countries", [id]);
                    return;
                  }

                  setFieldValue("Countries", [...countries, id]);
                } else {
                  setFieldValue(
                    "Countries",
                    countries.filter((x) => x !== id),
                  );
                }
              }}
              listError={touched.Countries && errors.Countries}
            />
            <div className="col-12 px-4 px-xl-5">
              <Alerts
                variant={"danger"}
                buttonContent={
                  getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
                }
                content={
                  getDir(getCurrentLangFromRedux()) == "rtl"
                    ? "هذا الملف تم رفعه من قبل"
                    : "this file uploaded already"
                }
                title={
                  getDir(getCurrentLangFromRedux()) == "rtl"
                    ? "ملف متكرر"
                    : "duplicate file"
                }
                show={duplicateAlert}
                setShow={setDuplicateAlert}
              />
            </div>
            <div className="d-flex flex-column mx-4 px-xl-4 mb-3">
              <FileUploader
                containerStyle={"col-12"}
                contentStyle={"col-12"}
                borderColor={"#C7C7C9"}
                placeholderLTRWidth={150}
                placeholderRTLWidth={115}
                fileIconColor={"#1a73e8"}
                fileValue={values.file}
                fileOnClick={(e) => {
                  e.target.value = "";
                  setFieldValue("file", e.target.value);
                }}
                FileOnChange={(e) => {
                  setFieldValue("file", e.target.files[0]);
                }}
                uploadButtonOnChange={() => {
                  if (values.file) {
                    if (
                      !files.find(
                        (item) =>
                          item.fileName === values.file.name.substr(0, 35),
                      )
                    ) {
                      const allFiles = [
                        ...files,
                        {
                          id: files.length + 1,
                          fileName: values.file.name.substr(0, 35),
                          file: values.file,
                        },
                      ];
                      setFieldValue("files", [...allFiles]);
                      setFiles([...allFiles]);
                      setFieldValue("file", "");
                      setFieldTouched("files", false);
                    } else {
                      setDuplicateAlert(true);
                      setTimeout(() => {
                        setDuplicateAlert(false);
                      }, 1000);
                    }
                  }
                }}
              />
              <FilesList
                containerStyle={"col-12 justify-content-start"}
                contentStyle={"col-12"}
                Data={[...files]}
                setFiles={setFiles}
                setFilesInFormik={setFieldValue}
                setFilesTouched={setFieldTouched}
                propInFormik={"files"}
              />
            </div>
            <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
              <Button
                // content={Lang.save}
                containerStyle="col-3 mx-3"
                // onClick={() => {
                //   if (values.AdminTaskMembers.length > 0)
                //     setAdminListError(false);
                //   else setAdminListError(true);
                // }}
                type={"submit"}
                // onClick={() => {
                //   console.log("clicked 1");
                //   if (values.AdminTaskMembers !== null)
                //     setAdminListError(false);
                //   else setAdminListError(true);
                // }}
                disable={isSubmitting}
                content={isSubmitting ? Lang.isSaving : Lang.save}
                buttonStyleType={"solid"}
              />

              <Button
                content={Lang.cancel}
                containerStyle="col-3 mx-3"
                onClick={() => {
                  onHide();
                  setPriorityDropdownList(communityTaskForm.priorityLkp);
                  setTaskStatusDropdownList(communityTaskForm.taskStatusLkp);
                  setStartDate("");
                  setEndDate("");
                  setFiles([]);
                  resetForm();
                  setAdminListError(false);
                  setDisable(false);
                }}
              />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  } else {
    return <div></div>;
  }
};
export default CreateNewTask;
